import { gql } from "@apollo/client";

export const RATINGS_NEW_ORDER = gql`
  mutation createRatingsOrder($order: RatingsOrders) {
    createRatingsOrder(order: $order) {
      answer
    }
  }
`;

export const SEARCH_TERMS_NEW_ORDER = gql`
  mutation createSearchTermsOrder($order: Order) {
    addApplication(order: $order) {
      order
    }
  }
`;

export const REVIEWS_NEW_ORDER = gql`
  mutation createReviewsOrder($order: ReviewsOrders) {
    createReviewsOrder(order: $order) {
      answer
    }
  }
`;

export const CHANGE_ORDER_STATUS = gql`
  mutation changeOrderStatusAdmin(
    $userId: Int
    $orderType: OrderType
    $hashId: Int!
    $status: OrderStatus
  ) {
    changeOrderStatusAdmin(userId: $userId, orderType: $orderType, hashId: $hashId, status: $status)
  }
`;

export const SET_ORDER_MANAGER = gql`
  mutation setOrderManager(
    $orderType: OrderType!
    $orderId: Int!
    $managerId: Int
  ) {
    setOrderManager(
      orderType: $orderType
      orderId: $orderId
      managerId: $managerId
    )
  }
`;

export const GET_USER_ORDERS = gql`
  query getAllOrders {
    getAllOrders {
      id
      isFavorite
      status
      totalAmountOfRatings
      totalInstalls
      pricePerInstall
      keywordsToPromote
      orderType
      subtype
      orderCompletion
      initialDate
      createdAt
      endDate
      orderPrice
      buyingPrice
      hashId
      app {
        title
        appId
        country
        icon
        store
      }
      user {
        id
        name
        email
        manager {
          id
          name
          email
        }
      }
      admin {
        id
        name
        email
      }
    }
  }
`;

export const GET_ORDER_BY_TYPE_AND_ID = gql`
  query getOrderByTypeAndId($orderType: OrderType, $orderId: Int) {
    getOrderByTypeAndId(orderType: $orderType, orderId: $orderId) {
      id
      hashId
      orderId
      orderCompletion
      status
      orderPrice
      totalInstalls
      pricePerInstall
      isFavorite
      orderType
      subtype
      initialDate
      createdAt
      endDate
      user {
        name
        email
        phone
        telegram
        role
        timezone
        id
        manager {
          name
          email
        }
      }
      admin {
        name
        email
        phone
        telegram
        role
      }
      app {
        id
        appId
        title
        store
        country
      }
      ratingsPerDay {
        date
        fourStarRating
        fiveStarRating
      }
      reviews {
        username
        reviewText
        reviewDate
        reviewEvaluation
      }
      keywords {
        keyword
        totalInstalls {
          current
          target
          price
        }
        totalVisits {
          current
          target
          price
        }
        visits {
          date
          time
          visits
          total
          price
          timeRange
          startTime
          endTime
          appOpeningDayTwo
          isPausedDay
          status
          completedPercentage
          completedPrice
        }
        installs {
          date
          time
          installs
          total
          price
          timeRange
          startTime
          endTime
          appOpeningDayTwo
          isPausedDay
          status
          completedPercentage
          completedPrice
        }
      }
    }
  }
`;

export const KEYWORDS_NEW_ORDER = gql`
  mutation createKeywordsOrder($order: KeywordsOrders) {
    createKeywordsOrder(order: $order) {
      answer
    }
  }
`;

export const GET_TRAFFIC_SOURCES = gql`
  query getTrafficSources {
    getTrafficSources {
      id
      email
      orderType
      reservationStatus
      price
      platform
    }
  }
`;

export const ADD_TRAFFIC_SOURCES = gql`
  mutation addTrafficSource($trafficSource: TrafficSourceInput) {
    addTrafficSource(trafficSource: $trafficSource) {
      email
      orderType
      reservationStatus
      price
      platform
    }
  }
`;

export const EDIT_TRAFFIC_SOURCES = gql`
  mutation editTrafficSource($trafficSource: TrafficSourceInput) {
    editTrafficSource(trafficSource: $trafficSource) {
      id
      email
      orderType
      reservationStatus
      price
      platform
    }
  }
`;

export const DELETE_TRAFFIC_SOURCES = gql`
  mutation deleteTrafficSource($id: Int) {
    deleteTrafficSource(id: $id) {
      id
      email
      orderType
      reservationStatus
      price
      platform
    }
  }
`;
